// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M3.5 4L7.5 8L3.5 12', 'M8.5 4L12.5 8L8.5 12'];
